import { FC } from 'react' 
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { observer } from 'mobx-react-lite'

import { yupResolver } from '@hookform/resolvers/yup'
import { useSchema } from './schema'
import { useRouteState } from '@shared/utils'
import { useLayoutContext } from '@sr/routes/common/layout-provider'
import { useEffect } from 'react'
import { UserInfo } from '@sr/ui'
import { Button, Form, BUTTON_SIZES } from '@shared/ui'

import { TrustedPersonBlockState } from './state'

import '../../../styles.scss'

export const TrustedPersonBlock: FC = observer(() => {
  const { id: policyId } = useParams()
  const {
    isLoading,
    trustedPersonData,
    isEditing,
    setEditingMode,
    saveTrustedPersonOnlyData,
  } = useRouteState(TrustedPersonBlockState, {
    policyId,
  })

  const { t } = useTranslation()
  const { setIsLoading } = useLayoutContext()

  const onStartEditing = () => {
    setEditingMode(true)
  }

  const schema = useSchema(t)
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {} as any,
  })

  const {
    handleSubmit,
    formState: { dirtyFields },
  } = methods

  const onSubmit = handleSubmit((form) => {
    const modifiedFormData = Object.fromEntries(
      Object.entries(form).filter(([key]) => dirtyFields[key]),
    )

    saveTrustedPersonOnlyData(modifiedFormData)
    setEditingMode(false)
  })

  const onCancel = () =>{
    setEditingMode(false)
  }

  useEffect(() => {
    setIsLoading(isLoading)
  }, [isLoading])

  if (!trustedPersonData || trustedPersonData.length <= 0) return null

  return (
    <div className="w-full grid grid-cols-1 max-w-4xl items-center justify-center self-center text-base font-normal" >
      <Form methods={methods} className="w-full" dataTestId='profile'>
        <div className="grid grid-cols-2 w-full">
          <div className="text-primary text-xl font-semibold mb-5">
            {t('userArea.profile.trustedPerson.title')}
          </div>
          <div className='flex flex-col items-end pr-[55px]'>
            {isEditing ? (
              <button type="button" onClick={onCancel} title={t('common:cancel')} className='underline text-primary font-semibold cursor-pointer'>
                {t('common:cancel')}
              </button>
            ) : (
              <button type="button" onClick={onStartEditing} className='underline text-primary font-semibold cursor-pointer'>{t('userArea.profile.actions.editProfile.button')}</button>
            )}
          </div>
        </div>
        <UserInfo data={trustedPersonData} useOnlyTwoColumns={true} />
        { isEditing && (
          <div className='mb-6'>
            <Button
              onClick={onSubmit}
              size={BUTTON_SIZES.small}
              disabled={isLoading}
            >
              {t('common:save')}
            </Button>
          </div>
        )}
      </Form>
      <hr className='bg-gray-200 w-full h-px mb-6' />
    </div>
  )
})
